/** @deprecated */
export class DropdownOption {
  private visible = true;
  private selected = false;

  constructor(
    private id: number,
    private label: string
  ) {}

  public getId(): number {
    return this.id;
  }

  public getLabel(): string {
    return this.label;
  }

  public isVisible(is?: boolean): boolean {
    if (typeof is !== "undefined") {
      this.visible = is;

      if (!this.isVisible) {
        this.selected = false;
      }
    }

    return this.visible;
  }

  public isSelected(): boolean {
    return this.selected;
  }

  public toggleSelect(): void {
    this.selected = !this.selected;
  }

  public deselect(): void {
    this.selected = false;
  }

  public select(): void {
    this.selected = true;
  }
}
